import { 
    call,
    takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";

export default function* paymentForPaymentDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `payments/${action.payload?.paymentId}`);

    const payment = PaymentFactory.create(res.data);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, payment);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPaymentForPaymentDetailsPage() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_FOR_PAYMENT_DETAILS_PAGE, paymentForPaymentDetailsPage);
}
